// extracted by mini-css-extract-plugin
export default {"root":"IconInbox_root__CHn2w"};